<template>
  <div class="todo-view-coupon">
    <el-row type="flex" class="todo-provider">
      <el-col>
          <el-collapse @change="defaultCollpaseView" v-model="defaultCollpaseVal" accordion>
            <el-collapse-item title="View Services Discount" name="1">
            <el-divider />
              <!-- <template align="right">
                <div align="right">
                  <export-excel :data="getDiscountsList" name="services_discount_list.xls"><el-button icon="el-icon-download" type="success" size="mini">Download Excel</el-button></export-excel>
                  <el-select v-model="discountStatus" placeholder="Status" @change="changeDiscountStatus($event)">
                  <el-option value="">All</el-option>
                  <el-option value="active" label="Active">Active</el-option>
                  <el-option value="inactive" label="InActive">InActive</el-option>
                </el-select>
                <el-input class="searchBox"
                v-model="tableSearch"
                placeholder="Type to search"/>
                </div>
              </template> -->
              <template>
                <el-col :span="24">
                <div align="right">
                  <export-excel class ="export-excel" :data="getDiscountsList" name="services_discount_list.xls"><el-button icon="el-icon-download" type="success" size="mini">Download Excel</el-button></export-excel>
                </div>
                </el-col>
                <el-col :span="24">
                <div align="right">
                  <el-select v-model="discountStatus" placeholder="Status" @change="changeDiscountStatus($event)">
                    <el-option value="">All</el-option>
                    <el-option value="active" label="Active">Active</el-option>
                    <el-option value="inactive" label="InActive">InActive</el-option>
                  </el-select>
                <el-input class="searchBox"
                v-model="tableSearch"
                placeholder="Type to search"/>
                </div>
                </el-col>
              </template>
              <el-table :data="getDiscountsList.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) || data.title.toLowerCase().includes(tableSearch.toLowerCase()) || data.email.toLowerCase().includes(tableSearch.toLowerCase()))"
                style="width: 100%" height="400" v-loading="loading">
                <el-table-column width="350"
                  label="Service Provider"
                  prop="name">
                    <template slot-scope="scope">
                    <div style="margin-left: 10px"><b>Name:</b> {{ scope.row.name }}</div>
                    <div style="margin-left: 10px"><b>Email:</b> {{ scope.row.email }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="150"
                  label="Service Name"
                  prop="title">
                </el-table-column>
                <el-table-column width="150"
                  label="Discount"
                  prop="discount">
                  <template slot-scope="scope">
                      <template v-if="scope.row.discountType === 'percent'">
                        <span>{{scope.row.discount}}%</span>
                      </template>
                      <template v-else>
                        <span>{{scope.row.discount}}$</span>
                      </template>
                    </template>
                </el-table-column>
                <el-table-column width="150"
                  label="Start Date"
                  prop="startDate">
                    <template slot-scope="scope">
                      {{ scope.row.startDate | formatDateWithoutTime }}
                    </template>
                </el-table-column>
                <el-table-column width="150"
                  label="Expiry Date"
                  prop="expiryDate">
                    <template slot-scope="scope">
                      {{ scope.row.expiryDate | formatDateWithoutTime }}
                    </template>
                </el-table-column>
                <el-table-column width="100"
                  label="Status"
                  prop="status">\
                    <template slot-scope="scope">
                      <template v-if="scope.row.status === 1">
                        <span>Active</span>
                      </template>
                      <template v-else>
                        <span>InActive</span>
                      </template>
                    </template>
                </el-table-column>
                <el-table-column width="150">
                  <template slot-scope="scope">
                    <template v-if="scope.row.status === 1">
                      <el-button type="warning"
                      @click="handleActive(scope.$index, scope.row)">Make InActive</el-button>
                    </template>
                    <template v-else>
                      <el-button type="success"
                      @click="handleActive(scope.$index, scope.row)">Make Active</el-button>
                    </template>
                    <el-button type="danger"
                      @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
            <el-collapse-item title="View Coupons" name="2">
              <el-divider />
              <template>
                <el-col :span="24">
                <div align="right">
                  <export-excel class ="export-excel" :data="getCouponsList" name="coupons_list.xls"><el-button icon="el-icon-download" type="success" size="mini">Download Excel</el-button></export-excel>
                </div>
                </el-col>
                <el-col :span="24">
                <div align="right">
                  <el-select v-model="couponStatus" placeholder="Status" @change="changeCouponStatus($event)">
                    <el-option value="">All</el-option>
                    <el-option value="active" label="Active">Active</el-option>
                    <el-option value="inactive" label="InActive">InActive</el-option>
                  </el-select>
                <el-input class="searchBox"
                v-model="tableSearch1"
                placeholder="Type to search"/>
                </div>
                </el-col>
              </template>
              <!-- <template><h3>In progress</h3></template> -->
              <el-table :data="getCouponsList.filter(data => !tableSearch1 || data.name.toLowerCase().includes(tableSearch1.toLowerCase()) || data.title.toLowerCase().includes(tableSearch1.toLowerCase()) || data.email.toLowerCase().includes(tableSearch1.toLowerCase()))"
                style="width: 100%;" height="400" v-loading="loading">
                <el-table-column width="350"
                  label="User Type"
                  prop="userTypeLabel">
                </el-table-column>
                <el-table-column width="350"
                  label="Condition"
                  prop="parsedCondition">
                  <template slot-scope="scope" v-html="scope.row.parsedCondition">
                    <span v-html="scope.row.parsedCondition"> ddd</span>
                  </template>
                </el-table-column>
                <el-table-column width="150"
                  label="Coupon Code"
                  prop="couponCode">
                </el-table-column>
                <el-table-column width="150"
                  label="Discount"
                  prop="discount">
                    <template slot-scope="scope">
                      <template v-if="scope.row.discountType === 'percent'">
                        <span>{{scope.row.discount}}%</span>
                      </template>
                      <template v-else>
                        <span>{{scope.row.discount}}$</span>
                      </template>
                    </template>
                </el-table-column>
                <el-table-column width="150"
                  label="Expiry Date"
                  prop="expiryDate">
                    <template slot-scope="scope">
                      {{ scope.row.expiryDate | formatDateWithoutTime }}
                    </template>
                </el-table-column>
                <el-table-column width="100"
                  label="Status"
                  prop="status">\
                    <template slot-scope="scope">
                      <template v-if="scope.row.status === 1">
                        <span>Active</span>
                      </template>
                      <template v-else>
                        <span>InActive</span>
                      </template>
                    </template>
                </el-table-column>
                <el-table-column width="150">
                  <template slot-scope="scope">
                    <template v-if="scope.row.status === 1">
                      <el-button type="warning"
                      @click="handleActive(scope.$index, scope.row)">Make InActive</el-button>
                    </template>
                    <template v-else>
                      <el-button type="success"
                      @click="handleActive(scope.$index, scope.row)">Make Active</el-button>
                    </template>
                    <el-button type="danger"
                      @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getServiceDiscounts, updateServiceDiscounts, getCoupons } from '@/api/vouchers'

  import excel from 'vue-excel-export'
  import Vue from 'vue'
  Vue.use(excel)

  export default {
    props: {
      user: Object,
      resetTab: String
    },
    watch: {
      resetTab: function(newVal, oldVal) {
        if (newVal === 'true') {
          this.defaultCollpaseView()
        }
      }
    },
    data() {
      return {
        getDiscountsList: [],
        defaultCollpaseVal: '',
        loading: true,
        tableSearch: '',
        discountStatus: '',
        // coupon
        tableSearch1: '',
        getCouponsList: [],
        couponStatus: '',
        userTypeConditions: { equalTo: 'Equal To', greaterThan: 'Greater Than', lessThan: 'Less Than', greaterThanEqualTo: 'Greater Than Equal To', lessThanEqualTo: 'Less Than Equal To' }
      }
    },
    methods: {
      async viewServiceDiscountsFunc(discountStatus) {
        try {
          const { data } = await getServiceDiscounts(discountStatus)
          this.getDiscountsList = data
          } catch (err) {
        }
        this.loading = false
      },
      defaultCollpaseView() {
        if (this.defaultCollpaseVal === '1') {
          this.loading = true
          this.viewServiceDiscountsFunc('')
        } else if (this.defaultCollpaseVal === '2') {
          this.loading = true
          this.viewCouponsFunc('')
        }
        this.discountStatus = ''
        this.couponStatus = ''
      },
      handleActive(index, row) {
        const isactive = (row.status === 1) ? '0' : '1'
        const dataArr = {
          status: isactive
        }
        this.updateServiceDiscountsFunc(dataArr, row.id)
      },
      handleDelete(index, row) {
         const dataArr = {
          status: 0,
          deleteAt: 1
        }
         this.updateServiceDiscountsFunc(dataArr, row.id)
      },
      async updateServiceDiscountsFunc(dataArr, id) {
        this.loading = true
        try {
        await updateServiceDiscounts(dataArr, id)
        this.viewServiceDiscountsFunc(this.discountStatus)
        } catch (err) {
        }
        this.loading = false
      },
      changeDiscountStatus() {
        this.loading = true
        this.viewServiceDiscountsFunc(this.discountStatus)
      },
      // coupon
      async viewCouponsFunc(couponStatus) {
        try {
          const { data } = await getCoupons(couponStatus)
          this.getCouponsList = data
          this.getCouponsList.forEach(element => {
            const desc = JSON.parse(element.couponCondition)
            element.parsedCondition = ''
            for (const i in desc) {
              if (desc[i].condition) {
                const temp = desc[i].condition
                element.parsedCondition += this.userTypeConditions[temp] + ': ' + desc[i].value + '<br>'
              }
            }
          })
        } catch (err) {
        }
        this.loading = false
      },
      changeCouponStatus() {
        this.loading = true
        this.viewCouponsFunc(this.couponStatus)
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .el-button{
    margin:2px!important;width:auto!important
  }

  tr.el-table__row:hover{
    background-color:rgb(238, 237, 230)!important
  }
  .export-excel{
    display: inline-block;
  }
</style>
